import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { ITRFRejectReasonResponse } from "@/api_framework/api_modals/LabReport";

AxiosCurlirize(axios, () => {});

export const useLabPartnerTrfRejectReasonAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  // const [trfRejectReason, setTrfRejectReason] = useState<ITRFRejectReasonResponse | null>(null);
  const [trfRejectReason, setTrfRejectReason] = useState<string[]>([]);

  const configuration = useConfiguration();

  const execute = useCallback(
    async () => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
            .get(LAB_REPORT?.LAB_REPORT_TRF_REJECT_REASON_LIST?.baseURL, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              setTrfRejectReason(res.data.data);
            } else {
              setTrfRejectReason(null);
            }
          })
          .catch((e: AxiosError) => {
            setTrfRejectReason(null);
            sendCurl(e.config["curlCommand"]);
            captureError(e);
          });
      } catch (e: any) {
        setTrfRejectReason(null);
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute, trfRejectReason };
};
